var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"like-wraper"},[_c('div',{staticClass:"animation",class:_vm.animation ? 'start' : '',on:{"click":_vm.like}}),_c('div',{staticClass:"like-count"},[_vm._v(_vm._s(_vm.totalCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }